import { useTranslation } from 'react-i18next';

import type { Patient } from '../types/patient.types';

interface PatientStatusBadgeProps {
  patient: Patient;
}

// PRD 02 §4.4: 3 visual variants — Active (green) / Closed · {reason} (gray) /
// Withdrawn (red). The "ending soon" orange chip was deleted in v1.1; active
// rows always render the plain "관리중" badge.
export function PatientStatusBadge({ patient }: PatientStatusBadgeProps) {
  const { t } = useTranslation('admin');

  if (patient.status === 'WITHDRAWN') {
    return (
      <span className="badge badge-destructive">
        {t('patientManagement.statusBadges.WITHDRAWN')}
      </span>
    );
  }

  if (patient.status === 'CLOSED') {
    const reason = patient.closeReason
      ? t(`patientManagement.closeReasons.${patient.closeReason}`)
      : null;
    const label = reason
      ? t('patientManagement.statusBadges.closedWithReason', { reason })
      : t('patientManagement.statusBadges.CLOSED');
    const tooltip = patient.closedAt
      ? `${label} (${patient.closedAt})`
      : label;
    return (
      <span className="badge badge-closed" title={tooltip}>
        {label}
      </span>
    );
  }

  return (
    <span className="badge badge-active">
      {t('patientManagement.statusBadges.ACTIVE')}
    </span>
  );
}
